import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.083 16.083a.583.583 0 110 1.167.583.583 0 010-1.167zm0-4.666a.583.583 0 110 1.166.583.583 0 010-1.166zm0-4.667a.583.583 0 110 1.167.583.583 0 010-1.167zM14.917 16.083a.583.583 0 110 1.167.583.583 0 010-1.167zm0-4.666a.583.583 0 110 1.166.583.583 0 010-1.166zm0-4.667a.583.583 0 110 1.166.583.583 0 010-1.166z"
                fill={'#999'}
            />
            <path
                d="M9.083 16.083a.583.583 0 110 1.167.583.583 0 010-1.167zm0-4.666a.583.583 0 110 1.166.583.583 0 010-1.166zm0-4.667a.583.583 0 110 1.167.583.583 0 010-1.167zM14.917 16.083a.583.583 0 110 1.167.583.583 0 010-1.167zm0-4.666a.583.583 0 110 1.166.583.583 0 010-1.166zm0-4.667a.583.583 0 110 1.166.583.583 0 010-1.166z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
